// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"c3ee03fa","237":"7f19be5f","244":"659d1e23","410":"0b3ef156","425":"e7c24541","548":"914dfbc2","638":"f70b80f5","881":"8539d530","907":"6146e3a4","971":"a0a2fc18"}[chunkId] + ".chunk.js";
};